import { useState } from 'react';

import { MobileSearchFilterButton } from '#/components/MobileSearchFilterButton/MobileSearchFilterButton';
import { MobileSearchMenu } from '#/components/MobileSearchMenu/MobileSearchMenu';
import { MobileSearchQueryField } from '#/components/MobileSearchQueryField/MobileSearchQueryField';
import type { LocationRadiusSelectHandle } from '#/components/LocationRadiusSelect/LocationRadiusSelect';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import type { SearchType } from '#/modules/search/types/SearchType';

import { MobileSearchDialog } from './MobileSearchDialog';
import { MobileSearchV2Holder } from './MobileSearchV2.styled';

// TODO(@paprikka) Phase 2: move search refinements into a dedicated filter modal

type Props = {
  defaultSearchType: SearchType;
  initialQuery: string;
  searchLocation: SearchLocation | undefined;
  onChangeSearchLocation: (
    newSearchLocation: SearchLocation | undefined,
  ) => boolean;
  radiusOptions: { label: string; value: string }[];
  radiusHandle: LocationRadiusSelectHandle;
  onSearch: (data: {
    listingType: SearchType;
    query: string;
    radius: string;
    triggeredByRemoteLocationChange: boolean;
  }) => void;
  searchOnClear: boolean;
};

export function MobileSearchV2({
  defaultSearchType,
  initialQuery,
  searchLocation,
  onChangeSearchLocation,
  radiusOptions,
  radiusHandle,
  onSearch,
  searchOnClear,
}: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <MobileSearchV2Holder>
        <MobileSearchQueryField
          query={initialQuery}
          location={searchLocation?.text ?? undefined}
          onClick={() => setIsMenuOpen(true)}
        />
        <MobileSearchFilterButton />
      </MobileSearchV2Holder>

      {isMenuOpen && (
        <MobileSearchDialog onClose={() => setIsMenuOpen(false)}>
          <MobileSearchMenu
            defaultSearchType={defaultSearchType}
            initialQuery={initialQuery}
            searchLocation={searchLocation}
            onChangeSearchLocation={onChangeSearchLocation}
            radiusOptions={radiusOptions}
            radiusHandle={radiusHandle}
            onSearch={onSearch}
            searchOnClear={searchOnClear}
            onClose={() => setIsMenuOpen(false)}
          />
        </MobileSearchDialog>
      )}
    </>
  );
}
